const DpoCoreUpozorneniZadatele = {
    init: function () {
        const field = $("#nazevprojektu");

        if (!field.length) {
            return;
        }

        const upozorneni = field.data("upozorneni-zadatele");

        if (!upozorneni) {
            return;
        }


        let text = '<div class="text-center">';
        text += '<i class="fa fa-exclamation-triangle fa-fw fa-5x mt-3 mb-4 text-danger"></i>';
        text += "</div>";
        text += '<p class="text text-center font-weight-bold" style="font-size: 1.1rem">';
        text += upozorneni;
        text += "</p>";

        WilleModal.setId("modal-upozorneni");
        WilleModal.disableClose();
        WilleModal.setTitle('Upozornění');
        WilleModal.setContent(text);
        WilleModal.addButton("confirm", "<i class=\"fa fa-fw fa-check\"></i> Rozumím", "btn btn-primary", function() {
            WilleModal.close()
        });
        WilleModal.build();
    }
}

$(document).ready(function () {
    DpoCoreUpozorneniZadatele.init();
});